import { convert } from 'html-to-text'

export const htmlToPlainText = (html: string) => {
    return convert(html, {
        wordwrap: false,
        selectors: [
            { selector: 'h1', options: { uppercase: false } },
            { selector: 'h2', options: { uppercase: false } },
            { selector: 'h3', options: { uppercase: false } },
            { selector: 'h4', options: { uppercase: false } },
            { selector: 'h5', options: { uppercase: false } },
            { selector: 'h6', options: { uppercase: false } },
            { selector: 'a', options: { ignoreHref: true } },
            { selector: 'img', format: 'skip' },
            { selector: 'ul', options: { itemPrefix: '• ' } },
        ],
    })
        .replace(/^[ \t]+(?=(?:•|\d+[.)]) )/gm, '')
        .replace(/\n{3,}/g, '\n\n')
        .trim()
}
